import { useCallback } from 'react';
import { Typography, Card, List, Button, Tag } from 'antd';
import { ShopOutlined, PlusOutlined, RobotOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import { useBusinessStore } from '../store/businessStore';
import { useRefreshOnVisibility } from '../hooks/useRefreshOnVisibility';
import { telegram } from '../utils/telegram';
import type { Business } from '../types/business';

const { Title, Text } = Typography;

export default function BusinessListPage() {
  const { businesses, selectBusiness } = useBusinessStore();
  const navigate = useNavigate();

  // Re-expand the Telegram viewport when the WebApp is re-activated
  // (e.g. user returned after Android hardware back). Without this the
  // viewport can stay collapsed at 0 height and the page renders blank.
  const handleReopen = useCallback(() => {
    WebApp.expand();
  }, []);
  useRefreshOnVisibility(handleReopen);

  const handleSelect = (business: Business) => {
    telegram.hapticFeedback.impact('light');
    selectBusiness(business);
  };

  const handleAddBusiness = () => {
    telegram.hapticFeedback.impact('light');
    navigate('/owner-onboarding');
  };

  return (
    <div style={{ padding: '16px 16px 80px' }}>
      <Title level={4} style={{ marginBottom: 4 }}>
        Bizneslaringiz
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {'Boshqarmoqchi bo\'lgan biznesni tanlang'}
      </Text>

      <List
        dataSource={businesses}
        renderItem={(business) => (
          <List.Item style={{ padding: 0, marginBottom: 12, border: 'none' }}>
            <Card
              hoverable
              style={{ width: '100%' }}
              onClick={() => handleSelect(business)}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <ShopOutlined style={{ fontSize: 24, opacity: 0.6 }} />
                <div style={{ flex: 1 }}>
                  <Text strong>{business.businessName}</Text>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                    <RobotOutlined style={{ fontSize: 12, opacity: 0.5 }} />
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      @{business.botUsername}
                    </Text>
                  </div>
                </div>
                <Tag color={business.active ? 'green' : 'default'}>
                  {business.active ? 'Faol' : 'Nofaol'}
                </Tag>
              </div>
            </Card>
          </List.Item>
        )}
      />

      <Button
        type="dashed"
        icon={<PlusOutlined />}
        block
        size="large"
        onClick={handleAddBusiness}
        style={{ marginTop: 8 }}
      >
        {'Yangi biznes qo\'shish'}
      </Button>
    </div>
  );
}
